import { useState, useCallback, useRef } from 'react';
import * as cuisineOrderManagementAction from "../../../redux/store-sarang/cuisine-order/cuisine-order-management.store";
import ShowNotification from "../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../utils/configuration";

export const useCuisineOrderActions = (showLoading, getListCuisineOrderManagement, user, page, rowsPerPage, orderBy, order, receiptTimeOrder, searchData) => {
    const buttonOpenAddEditRef = useRef();
    const buttonOpenConfirmRef = useRef();
    const [isOpenAddEditDialog, setOpenAddEditDialog] = useState(false);
    const [isOpenDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [isOpenActiveDialog, setOpenActiveDialog] = useState(false);
    const [isOpenDeactiveDialog, setOpenDeactiveDialog] = useState(false);
    const [isOpenChangeStatusDialog, setOpenChangeStatusDialog] = useState(false);
    const [isOpenChangeConfirmDialog, setOpenChangeConfirmDialog] = useState(false);
    const [isOpenChangeDeliveryDialog, setOpenChangeDeliveryDialog] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const refreshList = useCallback(() => {
        let sortExpression = orderBy + ' ' + order + ((orderBy && orderBy !== "receiptTime") ? receiptTimeOrder : '');
        getListCuisineOrderManagement(page + 1, rowsPerPage, sortExpression, searchData);
    }, [getListCuisineOrderManagement, page, rowsPerPage, orderBy, order, receiptTimeOrder, searchData]);

    const openAddDialog = () => {
        setOpenAddEditDialog(true);
        if (buttonOpenAddEditRef.current) buttonOpenAddEditRef.current.click();
    };

    const openEditDialog = (item) => {
        setOpenAddEditDialog(true);
        setSelectedItem(item);
        if (buttonOpenAddEditRef.current) buttonOpenAddEditRef.current.click();
    };

    const closeAddEditDialog = () => {
        setOpenAddEditDialog(false);
        setSelectedItem(null);
    };

    const openConfirmDialog = (item) => {
        setSelectedItem(item);
        if (buttonOpenConfirmRef.current) buttonOpenConfirmRef.current.click();
    };

    const closeConfirmDialog = () => {
        setOpenDeleteDialog(false);
        setOpenActiveDialog(false);
        setOpenDeactiveDialog(false);
        setOpenChangeStatusDialog(false);
        setOpenChangeConfirmDialog(false);
        setOpenChangeDeliveryDialog(false);
        setSelectedItem(null);
    };

    const handleSubmitAddEditCuisineOrder = async (data) => {
        showLoading(true);
        try {
            let res = null;
            if (!data.id) {
                res = await cuisineOrderManagementAction.CreateCuisineOrder(data);
            } else {
                res = await cuisineOrderManagementAction.UpdateCuisineOrder(data);
            }
            if (res && res.content) {
                refreshList();
                closeAddEditDialog();
            }
        } catch (err) {
            showLoading(false);
            if (err) ShowNotification(err.errorMessage, NotificationMessageType.Error);
        }
    };

    const handleConfirm = async () => {
        try {
            let res = null;
            if (isOpenDeleteDialog) {
                res = await cuisineOrderManagementAction.DeleteCuisineOrder(selectedItem.id);
            } else if (isOpenActiveDialog) {
                res = await cuisineOrderManagementAction.ActiveCuisineOrder(selectedItem.id);
            } else if (isOpenDeactiveDialog) {
                res = await cuisineOrderManagementAction.DeActiveCuisineOrder(selectedItem.id);
            } else if (isOpenChangeStatusDialog) {
                res = await cuisineOrderManagementAction.ChangeCuisineOrderStatus({ id: selectedItem.id, status: selectedItem.orderStatusChange });
            } else if (isOpenChangeConfirmDialog) {
                res = await cuisineOrderManagementAction.ChangeConfirm({ id: selectedItem.id, herdsmanId: user.herdsmanId });
            } else if (isOpenChangeDeliveryDialog) {
                res = await cuisineOrderManagementAction.ChangeDelivery({ id: selectedItem.id, herdsmanId: selectedItem.herdsManDeliveryId });
            }

            if (res) {
                refreshList();
            }
            showLoading(false);
            closeConfirmDialog();
        } catch (err) {
            showLoading(false);
            if (err) ShowNotification(err.errorMessage, NotificationMessageType.Error);
        }
    };

    return {
        buttonOpenAddEditRef,
        buttonOpenConfirmRef,
        isOpenAddEditDialog, setOpenAddEditDialog,
        isOpenDeleteDialog, setOpenDeleteDialog,
        isOpenActiveDialog, setOpenActiveDialog,
        isOpenDeactiveDialog, setOpenDeactiveDialog,
        isOpenChangeStatusDialog, setOpenChangeStatusDialog,
        isOpenChangeConfirmDialog, setOpenChangeConfirmDialog,
        isOpenChangeDeliveryDialog, setOpenChangeDeliveryDialog,
        selectedItem, setSelectedItem,
        openAddDialog, openEditDialog, closeAddEditDialog,
        openConfirmDialog, closeConfirmDialog,
        handleSubmitAddEditCuisineOrder, handleConfirm
    };
};
